/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DuplicateDocumentDataFromJSON(json) {
    return DuplicateDocumentDataFromJSONTyped(json, false);
}
export function DuplicateDocumentDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        srcId: json['srcId'],
        destId: json['destId'],
    };
}
export function DuplicateDocumentDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        srcId: value.srcId,
        destId: value.destId,
    };
}
